import { useEffect } from 'react'
import { useRouteError } from 'react-router-dom'
import useSeqLogger from '../../app/seqLog'

function ErrorPage() {
    const error: any = useRouteError()
    const { logToSeq } = useSeqLogger()

    useEffect(() => {
        logToSeq({
            message: 'Route error occurred',
            level: 'Error',
            error,
        })
    }, [error, logToSeq])

    return (
        <>
            <main>
                <h1>Något gick fel</h1>
            </main>
        </>
    )
}

export default ErrorPage
